/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ad-host{display:flex;align-items:center;justify-content:center;max-width:100%;overflow:hidden;min-height:1px}ad-host:empty{display:none}ad-host.margin-bottom{margin-bottom:15px}ad-host.margin-top{margin-top:15px}ad-host>:not(img){width:100%;max-width:1200px}"];
export { styles as styles };
